import React, { useState } from 'react';
import { Clock, Calendar as CalendarIcon, ChevronRight } from 'lucide-react';

const RANGE_OPTIONS = [
    { label: 'Past 24h', value: '1d' },
    { label: 'Past 7d', value: '7d' },
    { label: 'Past 30d', value: '30d' },
    { label: 'All Time', value: 'all' }
];

const TimeRangeFilter = ({ onFilterChange }) => {
    const [mode, setMode] = useState('preset'); // 'preset' | 'custom'
    const [activePreset, setActivePreset] = useState('1d');
    const [customRange, setCustomRange] = useState({ start: '', end: '' });

    const handlePresetClick = (val) => {
        setMode('preset');
        setActivePreset(val);
        onFilterChange({ type: 'preset', value: val });
    };

    const handleCustomDateChange = (field, value) => {
        const newRange = { ...customRange, [field]: value };
        setCustomRange(newRange);
        if (newRange.start && newRange.end) {
            onFilterChange({ type: 'custom', value: newRange });
        }
    };

    return (
        <div className="flex items-center gap-3 animate-in fade-in duration-500">
            <div className="flex bg-gray-100/80 p-1 rounded-xl border border-gray-100 items-center">
                {RANGE_OPTIONS.map((opt) => (
                    <button
                        key={opt.value}
                        onClick={() => handlePresetClick(opt.value)}
                        className={`px-4 py-1.5 text-[12px] font-bold rounded-lg transition-all ${mode === 'preset' && activePreset === opt.value
                            ? 'bg-white text-red-600 shadow-sm'
                            : 'text-gray-500 hover:text-gray-700'
                            }`}
                    >
                        {opt.label}
                    </button>
                ))}

                <div className="w-[1px] h-4 bg-gray-200 mx-1" />

                {mode === 'custom' && <button
                    onClick={() => setMode('custom')}
                    className={`px-3 py-1.5 rounded-lg transition-all flex items-center gap-1.5 ${mode === 'custom' ? 'bg-white text-red-600 shadow-sm' : 'text-gray-500 hover:text-gray-700'
                        }`}
                >
                    <CalendarIcon size={14} />
                    <span className="text-[12px] font-bold">Custom</span>
                </button>}
            </div>

            {mode === 'custom' && (
                <div className="flex items-center gap-2 animate-in slide-in-from-left-2">
                    <input
                        type="date"
                        className="p-1.5 bg-white border border-gray-200 rounded-lg text-[12px] font-bold outline-none focus:border-red-500 shadow-sm"
                        onChange={(e) => handleCustomDateChange('start', e.target.value)}
                    />
                    <ChevronRight size={14} className="text-gray-300" />
                    <input
                        type="date"
                        className="p-1.5 bg-white border border-gray-200 rounded-lg text-[12px] font-bold outline-none focus:border-red-500 shadow-sm"
                        onChange={(e) => handleCustomDateChange('end', e.target.value)}
                    />
                </div>
            )}
        </div>
    );
};

export default TimeRangeFilter;